import { Uuid, Color } from "types/global";




export function generateColor(uuid: Uuid = "A"): Color {
	let index = 0
	for (let i = 0; i < uuid.length && i < 10; i++) index += uuid.charCodeAt(i)
	const color = Colors[index % Colors.length]
	return color as Color
}

/**
 * Creates a simple numeric hash from a string
 * @param str String to hash
 * @returns Numeric hash value
 */
export function hashString(str: string): number {
	if ( !str ) return 0
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		hash = ((hash << 5) - hash) + str.charCodeAt(i);
		hash |= 0; // Convert to 32bit integer
	}
	return Math.abs(hash);
}

/**
 * Gets a color based on a string hash
 * @param str String to hash
 * @param colorArray Array to select colors from (defaults to colors_per)
 * @returns Color from the specified array
 */
export function hashStringToColor(str: string, colorArray = Colors): Color {
	if ( !str ) return "#FF0000" as Color; // Default color if no string is provided
	const hash = hashString(str);
	return colorArray[hash % colorArray.length] as Color;
}

export const Colors = [
	"#FFD933", // Giallo brillante
	"#33B5FF", // Azzurro brillante
	"#FF5733", // Arancione brillante
	"#33FF57", // Verde brillante
	"#5733FF", // Blu brillante
	"#FF33E6", // Rosa brillante
	"#33FFEC", // Ciano brillante
	"#FF336E", // Rosso brillante
	"#33FFA6", // Verde acqua brillante
	"#B533FF", // Viola brillante
	"#FF3333", // Rosso vivo
	"#33FF33", // Verde vivo
	"#3333FF", // Blu vivo
	"#FFFF33", // Giallo vivo
	"#33FFFF", // Ciano vivo
	"#FF33FF", // Magenta vivo
	"#33B5FF", // Azzurro vivo
	"#FF5733", // Arancione vivo
	"#33FF57", // Verde vivo
	"#5733FF", // Blu vivo
	"#FF0080", // Rosa elettrico
	"#80FF00", // Verde lime elettrico
	"#0080FF", // Blu elettrico
	"#FF8000", // Arancione elettrico
	"#8000FF", // Viola elettrico
	"#00FF80", // Verde smeraldo elettrico
	"#FF0040", // Rosso cremisi brillante
	"#40FF00", // Verde acido brillante
	"#0040FF", // Blu cobalto brillante
	"#FF4000", // Arancione fuoco brillante
	"#4000FF", // Indaco brillante
	"#00FF40", // Verde menta brillante
	"#FF0099", // Fucsia brillante
	"#99FF00", // Giallo verde brillante
	"#0099FF", // Azzurro cielo brillante	"#FF9900", // Ambra brillante
	"#9900FF", // Viola ametista brillante
	"#00FF99", // Turchese brillante
	"#FF6600", // Arancione mandarino brillante
	"#6600FF", // Blu violetto brillante
	"#FF0066", // Rosa shocking
	"#66FF00", // Verde chartreuse
	"#0066FF", // Blu oceano
	"#FF6000", // Rosso arancio
	"#6000FF", // Viola regale
	"#00FF66", // Verde primavera
	"#FF3300", // Rosso fuoco
	"#3300FF", // Blu violaceo
	"#00FF33", // Verde neon
	"#FF0033", // Rosso scarlatto
	"#3300FF", // Indigo profondo
	"#FF3366", // Rosa corallo
	"#33FF66", // Verde mela
	"#3366FF", // Azzurro intenso
	"#FF6633", // Pesca brillante
	"#6633FF", // Lavanda elettrica
	"#33FF99", // Acquamarina brillante
	"#FF9933", // Oro brillante
	"#9933FF", // Orchidea elettrica
	"#33FF33", // Verde fluo
	"#FF3399", // Magenta vivace
	"#3399FF", // Celeste brillante
	"#99FF33", // Lime acido
	"#FF0099", // Rosa neon
	"#0099FF" // Blu cielo elettrico
]

